import GraphQLClient from 'ts/GraphQLClient'
import { RepoParams } from 'ts/types'
import {
  CostOptimizationActionInput,
  CostOptimizationInput,
  CostOptimizationRecommendation,
  CostOptimizationRecommendationParams,
  CreateCostOptimizationResponse,
  ProcessCostOptimizationResponse
} from '../types'
import { CREATE_COST_OPTIMIZATION } from './graphql/createCostOptimization'
import { GET_COST_OPTIMIZATION_RECOMMENDATIONS } from './graphql/getCostOptimizationRecommendations'
import { PROCESS_COST_OPTIMIZATION_RECOMMENDATION } from './graphql/processCostOptimizationRecommendation'

export default class SavingsManagementRepo {
  private client: GraphQLClient

  constructor({ GRAPHQL_URL, ID_TOKEN }: RepoParams) {
    this.client = new GraphQLClient({ url: GRAPHQL_URL, idToken: ID_TOKEN })
  }

  async getCostOptimizationRecommendations(
    params: CostOptimizationRecommendationParams
  ): Promise<CostOptimizationRecommendation> {
    const data = await this.client.request<{
      getCostOptimizationRecommendations: CostOptimizationRecommendation
    }>({
      query: GET_COST_OPTIMIZATION_RECOMMENDATIONS,
      variables: {
        params
      }
    })

    return data.getCostOptimizationRecommendations
  }

  async createCostOptimizationRecommendation(
    recommendation: CostOptimizationInput
  ): Promise<{ recommendation_id: string; status: string }> {
    const data = await this.client.request<{
      createCostOptimizationRecommendation: CreateCostOptimizationResponse
    }>({
      query: CREATE_COST_OPTIMIZATION,
      variables: { recommendation }
    })

    const { createCostOptimizationRecommendation } = data

    if (createCostOptimizationRecommendation.error) {
      throw new Error(createCostOptimizationRecommendation.error.message || 'API error')
    }

    return createCostOptimizationRecommendation.data
  }

  async processCostOptimizationRecommendation(action: CostOptimizationActionInput): Promise<{
    recommendation_id: string
    status: string
    last_action_user: string
    last_action_role: string
    updated_date: string
  }> {
    const data = await this.client.request<{
      processCostOptimizationRecommendation: ProcessCostOptimizationResponse
    }>({
      query: PROCESS_COST_OPTIMIZATION_RECOMMENDATION,
      variables: {
        action: action
      }
    })

    const { processCostOptimizationRecommendation } = data

    if (processCostOptimizationRecommendation.error) {
      throw new Error(processCostOptimizationRecommendation.error.message || 'API error')
    }

    return processCostOptimizationRecommendation.data
  }
}
